export const hrMode = (mode) => {

  switch (mode) {

    case "RESEND_MAIL":
      return `/hr/otp`;
    
    case "VERIFY_OTP":
      return `/hr/otp`;

    case "CREATE_PASSWORD":
      return "/hr/create-password"

    case "CREATE_COMPANY_INFO":
      return "/hr/company-info1"

    case "COMPANY_META_INFO":
      return "/hr/company-info2"

    case "COMPANY_CONTACT_INFO":
      return "/hr/company-info3"

    case "COMPANY_ADDRESS":
      return "/hr/company-address"

    case "DASHBOARD":
      return '/hr/home'

    case"2STEP_AUTH":
      return '/hr/login'

    default:
      return "/page-not-found";
  }
};
